
export enum TextBlockElementKind {
    Header = "Header",
    Body = "Body"
}

export enum WebsiteMode {
    Preview,
    Live,
    ReadOnly
}
